import { useSelector } from "react-redux";
import { Navigate, Route, Routes } from 'react-router-dom';
import AppLayout from '../pages/_layout/AppLayout';
import ForgotPassword from '../pages/auth/ForgotPassword';
import Login from '../pages/auth/Login';
import Page404 from '../pages/auth/Page404';
import ResetPassword from '../pages/auth/ResetPassword';
import { RootState } from "../redux/store";
import { menuRoutes } from './menu';
import ProtectedRoute from './ProtectedRoute';
import contents from './routes';

const AppRouter = () => {

  const user = useSelector((state: RootState) => state.auth);

  const renderRoute = (page: any, index: number, access: boolean = true) => {
    page.element = <ProtectedRoute component={page.element} access={access && page.access} />;
    return (
      <Route key={index} {...page}>
        {page.sub?.map((subPage: any, index: number) => renderRoute(subPage, index))}
      </Route>
    );
  };

  return (
    <Routes>
      <Route element={<AppLayout />}>
        {contents.map((page, index) => renderRoute(page, index))}
      </Route>

      <Route path={menuRoutes.auth.login} element={<Login />} />
      <Route path={menuRoutes.auth.forgot_password} element={<ForgotPassword />} />
      <Route path={menuRoutes.auth.reset_password} element={<ResetPassword />} />
      {user.isAuthenticated && <Route path="/" element={<Navigate to={ user.user?.dashboard ? menuRoutes.dashboard.path : menuRoutes.issues.path} />} />}
      {(!user.isAuthenticated) && <Route path="*" element={<Navigate to={menuRoutes.auth.login} />} />}
      {(user.isAuthenticated) && <Route path="*" element={<Page404 />} />}
    </Routes>
  );
};

export default AppRouter;